import React, { Component } from 'react'
import { Collapse, Button, Icon, Checkbox } from 'antd'
import { siteContent, subscriptions, services } from '@services/api'

export default class extends Component {
    state = {
        fields: {
            description: {},
            required_token: 0,
            required_fields: null
        },
        subscriptions: []
    }

    componentDidMount() {
        let description = {}
        siteContent
            .getSiteLngs()
            .then(res => res.data.map(item => (description[item.lng] = '')))
            .then(() => this.setState({ fields: { ...this.state.fields, description } }))
            .catch(err => console.log({ err }))
        subscriptions.getSubscriptions().then(res =>
            this.setState({
                subscriptions: res.data
                    .map(sub => {
                        const { id, name } = sub
                        return sub.type != 'AGENT' && { id, name, price: 0 }
                    })
                    .filter(sub => sub)
            })
        )
    }
    render() {
        const {
            fields: { description, required_token },
            subscriptions
        } = this.state
        const { Panel } = Collapse
        return (
            <>
                <div
                    style={{
                        flexDirection: 'row',
                        display: 'flex',
                        position: 'relative',
                        justifyContent: 'space-around',
                        alignItems: 'center'
                    }}
                >
                    <div
                        style={{ flexDirection: 'column', display: 'flex', position: 'relative', alignItems: 'center' }}
                    >
                        טקסט באתר לפי שפות:
                        <Collapse style={{ flexDirection: 'column', width: 350 }}>
                            {Object.keys(description).map((lng, idx) => (
                                <Panel header={`${lng}`} key={idx}>
                                    <input
                                        style={{ marginRight: 5, width: 320 }}
                                        value={description[lng]}
                                        onChange={e =>
                                            this.setState({
                                                fields: {
                                                    ...this.state.fields,
                                                    description: {
                                                        ...description,
                                                        [lng]: e.target.value
                                                    }
                                                }
                                            })
                                        }
                                    />
                                </Panel>
                            ))}
                        </Collapse>
                    </div>
                    <div style={{ flexDirection: 'column', display: 'flex', position: 'relative' }}>
                        תשלום לאחר שירות?
                        <input
                            type="checkbox"
                            style={{ alignSelf: 'center', marginTop: 15 }}
                            checked={!!required_token}
                            onChange={() =>
                                this.setState({ fields: { ...this.state.fields, required_token: +!required_token } })
                            }
                        />
                    </div>
                </div>
                <div style={{ flexDirection: 'column', display: 'flex', position: 'relative', marginTop: 20 }}>
                    <h6> הוסף מחיר השירות בהתאם למסלולים:</h6>
                    {subscriptions.map((sub, idx) => (
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                width: '40%',
                                justifyContent: 'space-between'
                            }}
                        >
                            <Checkbox
                                checked={sub.price !== null}
                                onChange={e =>
                                    this.setState({
                                        subscriptions: subscriptions.map(mod =>
                                            mod.id == sub.id ? { ...mod, price: mod.price === null ? 0 : null } : mod
                                        )
                                    })
                                }
                            />
                            <span
                                key={idx}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    width: '75%',
                                    justifyContent: 'space-between'
                                }}
                            >
                                {sub.name}
                                <input
                                    disabled={sub.price === null}
                                    style={{ width: 45 }}
                                    value={sub.price || 0}
                                    type="number"
                                    onChange={e =>
                                        this.setState({
                                            subscriptions: subscriptions.map(mod =>
                                                mod.id == sub.id ? { ...mod, price: e.target.value } : mod
                                            )
                                        })
                                    }
                                />
                            </span>
                        </div>
                    ))}
                </div>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                        style={{ marginTop: 35.5, width: 225 }}
                        onClick={() =>
                            services
                                .addNewService({ ...this.state })
                                .then(() => {
                                    alert('שירות נוסף בהצלחה!')
                                    this.props.refreshServiceList()
                                })
                                .catch(err => {
                                    console.log({ err })
                                    alert('שגיאה בעדכון שירות')
                                })
                        }
                    >
                        שמור שינויים <Icon type="check" />
                    </Button>
                </div>
            </>
        )
    }
}
